import React, { useState } from "react";
import { DayPicker } from "react-day-picker";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { format } from "date-fns";
import "react-day-picker/dist/style.css";

interface CallbackModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (date: string, time: string) => void;
  initialDate?: string;
  initialTime?: string;
}

const CallbackModal: React.FC<CallbackModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  initialDate,
  initialTime,
}) => {
  const [date, setDate] = useState<Date | undefined>(
    initialDate ? new Date(initialDate) : undefined
  );
  const [time, setTime] = useState(initialTime || "");

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-sm p-8 relative">
        <button
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-xl"
          onClick={onClose}
        >
          ×
        </button>
        <h2 className="text-lg font-semibold mb-4">Set Callback Date & Time</h2>
        <div className="mb-4 flex flex-col items-center">
          <div className="bg-white rounded-xl shadow p-2">
            <DayPicker
              mode="single"
              selected={date}
              onSelect={setDate}
              initialFocus
            />
          </div>
        </div>
        <Input
          type="time"
          value={time}
          onChange={(e) => setTime(e.target.value)}
          className="mb-4"
        />
        <Button
          className="bg-orange-600 hover:bg-orange-700 text-white w-full"
          onClick={() => {
            if (date && time) {
              onSubmit(format(date, "yyyy-MM-dd"), time);
              onClose();
            }
          }}
          disabled={!date || !time}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default CallbackModal;